import { render, staticRenderFns } from "./ImportObjectivesModal.vue?vue&type=template&id=33e9ba50"
import script from "./ImportObjectivesModal.vue?vue&type=script&lang=js"
export * from "./ImportObjectivesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports